import DOCUMENT_TYPE_CODES from '../constants/document-type-codes';

export const RESTRICTION_DOCUMENT_INFO = {
  REVIEW_OC: {
    documentType: DOCUMENT_TYPE_CODES.PURCHASE_ORDER,
    accept: '.pdf',
    errorMessage: 'Ocurrio un error al subir la orden de compra',
  },
  REVIEW_HES: {
    documentType: DOCUMENT_TYPE_CODES.HES,
    accept: '.pdf',
    errorMessage: 'Ocurrio un error al subir el documento',
  },
  REVIEW_PORTAL_SCREENSHOT: {
    documentType: DOCUMENT_TYPE_CODES.PORTAL_SCREENSHOT,
    accept: 'image/*,.pdf',
    errorMessage: 'Ocurrio un error al subir la imagen',
  },
  REVIEW_PAYMENT_STATUS: {
    documentType: DOCUMENT_TYPE_CODES.PAYMENT_STATUS,
    accept: '.pdf,image/*',
    errorMessage: 'Ocurrió un error al subir el comprobante de pago',
  },
  REVIEW_RECEPTION_ACKNOWLEDGMENT: {
    documentType: DOCUMENT_TYPE_CODES.RECEPTION_ACKNOWLEDGMENT,
    accept: '.pdf',
    errorMessage: 'Ocurrió un error al subir el acuse de recibo',
  },
  PDF_REQUIREMENT: {
    documentType: DOCUMENT_TYPE_CODES.PDF,
    accept: '.pdf',
    errorMessage: 'Ocurrio un error al subir el pdf',
  },
};

const RESTRICTION_DOCUMENT_CONFIG = {
  review_oc: {
    requireDocumentUpload: true,
    documentInfo: RESTRICTION_DOCUMENT_INFO.REVIEW_OC,
  },
  review_hes: {
    requireDocumentUpload: true,
    documentInfo: RESTRICTION_DOCUMENT_INFO.REVIEW_HES,
  },
  review_portal_screenshot: {
    requireDocumentUpload: true,
    documentInfo: RESTRICTION_DOCUMENT_INFO.REVIEW_PORTAL_SCREENSHOT,
  },
  review_payment_status: {
    requireDocumentUpload: true,
    documentInfo: RESTRICTION_DOCUMENT_INFO.REVIEW_PAYMENT_STATUS,
  },
  review_reception_acknowledgment: {
    requireDocumentUpload: true,
    documentInfo: RESTRICTION_DOCUMENT_INFO.REVIEW_RECEPTION_ACKNOWLEDGMENT,
  },
  PDF_REQUIREMENT: {
    requireDocumentUpload: true,
    documentInfo: RESTRICTION_DOCUMENT_INFO.PDF_REQUIREMENT,
  },
};

const buildRestrictionMessage = (
  label,
  id,
  restrictionKey = null,
  requireDocumentUpload = false,
) => {
  const documentInfo = restrictionKey ? RESTRICTION_DOCUMENT_INFO[restrictionKey] : null;

  return {
    id,
    restrictionLabel: label,
    status: 'CREATED',
    requireDocumentUpload,
    documentInfo,
  };
};

export const enrichRestrictionsWithDocumentConfig = (restrictions) => {
  if (!restrictions || !Array.isArray(restrictions)) return restrictions;
  return restrictions.map((restriction) => {
    const configKey = restriction.restriction || restriction.id;
    const config = RESTRICTION_DOCUMENT_CONFIG[configKey];
    if (config) {
      return {
        ...restriction,
        ...config,
      };
    }
    return restriction;
  });
};

export default buildRestrictionMessage;
